import { Clickable } from '@carvana/merch-components';
import { useState } from 'react';
import { useGetConsumerHref } from '@/common/SearchBar/utils';
import BackArrow from '~/icons/BackArrow';
import {
  LinkGrid,
  LinkSectionWrapper,
  Title,
  Link,
  ExpandButton
} from './InternalLinks.styles';

type LinkType = {
  link: string;
  text: string;
};

type OwnProps = {
  title: string;
  links: LinkType[];
};

export function LinkSection({ title, links = [] }: OwnProps) {
  const [isExpanded, setExpanded] = useState(false);
  const getHref = useGetConsumerHref();

  const showExpandButton = links.length > 9;
  const linksToShow = isExpanded ? links : links.slice(0, 9);

  return (
    <LinkSectionWrapper>
      <Title>{title}</Title>
      <LinkGrid>
        {linksToShow.map(({ link, text }) => (
          <Link
            data-analytics-id="Internal Link"
            data-analytics-attributes={JSON.stringify({ link: text })}
            key={text}
            href={getHref(`/cars${link}`)}
            className="text-grey-5 underline tl-link-m hover:text-blue-2 "
          >
            {text}
          </Link>
        ))}
      </LinkGrid>
      {showExpandButton && (
        <Clickable
          data-analytics-id="Internal Link Expand"
          element={ExpandButton}
          onClick={() => setExpanded(!isExpanded)}
        >
          View {isExpanded ? 'Less' : 'More'}{' '}
          <BackArrow
            primary
            className={isExpanded ? 'rotate-90' : '-rotate-90'}
          />
        </Clickable>
      )}
    </LinkSectionWrapper>
  );
}
